/** Maps PowerSync's status + pending local writes to the SyncPill state (PRD M14-08). */
export function pillState(status, pending, online) {
    if (!online)
        return "offline";
    if (!status)
        return pending > 0 ? "pending" : "syncing";
    const flow = status.dataFlowStatus;
    if (flow?.downloadError || flow?.uploadError)
        return "error";
    if (!status.connected)
        return pending > 0 ? "pending" : "offline";
    if (flow?.uploading || flow?.downloading)
        return "syncing";
    if (pending > 0)
        return "pending";
    return "synced";
}
/** Red banner threshold: unsynced for more than 48 h (PRD M14-08). */
export function staleSince(lastSyncedAt, now = new Date()) {
    if (!lastSyncedAt)
        return false;
    return now.getTime() - lastSyncedAt.getTime() > 48 * 3600_000;
}
//# sourceMappingURL=status.js.map